
    <div class="status-container">
        <div class="status-card">
            
            <!-- Successful Completion -->
            <div *ngIf="complete" class="success-section">
                <div class="status-icon success-icon">✓</div>
                <h1 class="status-title">Identification successfully completed!</h1>
                <p class="status-message">You can close this window now.</p>
                
                <div class="status-details">
                    <div class="detail-item">
                        <span class="detail-label">Status:</span>
                        <span class="detail-value success">{{foo?.result?.status}}</span>
                    </div>
                    <div class="detail-item" *ngIf="foo?.result?.transaction_id">
                        <span class="detail-label">Transaction ID:</span>
                        <span class="detail-value">{{foo.result.transaction_id}}</span>
                    </div>
                </div>
            </div>

            <!-- Pending Manual Review -->
            <div *ngIf="pending && !complete" class="pending-section">
                <div class="status-icon pending-icon">📄</div>
                <h1 class="status-title">Your data is currently being checked manually!</h1>
                <p class="status-message">We will inform you of the result by SMS when we have finished.</p>
                
                <button class="action-btn primary" (click)="refreshPage()">
                    <span class="btn-icon">🔄</span>
                    Refresh
                </button>
            </div>

            

            <!-- Failed Verification -->
            <div *ngIf="foo?.result?.status === 'FAILED' || foo?.result?.status === 'COMPLETED_FRAUD'" class="failed-section">
                <div class="status-icon error-icon">📄</div>
                <h1 class="status-title">Identification failed!</h1>
                <p class="status-message">Unfortunately, the identification process could not be completed successfully. Please restart the process.</p>
                
                <button class="action-btn primary" (click)="ngOnInit()">
                    Restart Identification
                </button>
            </div>

            <!-- System Error -->
            <div *ngIf="msg && msg.includes('Error')" class="system-error-section">
                <div class="status-icon error-icon">⚠️</div>
                <h1 class="status-title">System Error</h1>
                <p class="status-message">There was a technical issue with the verification system.</p>
                
                <div class="error-details">
                    <p>{{msg}}</p>
                </div>

                <button class="action-btn primary" (click)="ngOnInit()">
                    <span class="btn-icon">🔄</span>
                    Retry Connection
                </button>
            </div>

            <ngx-spinner size="medium" [type]="typeSelected"></ngx-spinner>
        </div>
    </div>